import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useCartContext } from "../../context/CartContext";
import RequestClass from "../../classes/RequestClass";
import { CheckIfUserIsLogged } from "../../classes/LoginHelper";
import { InvoiceFormInputs } from "../../components/forms/InvoiceFormInputs";
import { ADDR_TYPE_CHOICES, BASKET_TYPE_CHOICES, BASKET_UNKNOWN } from "../../components/Enumerators";
import CartClass from "../../classes/CartClass";

const CartCustomerDetails = () => {
    let basketId = CartClass.get_basketId(BASKET_TYPE_CHOICES.BASKET_ORDER);

    if (basketId === BASKET_UNKNOWN) {
        CheckIfUserIsLogged("koszyk");
    } else {
        CheckIfUserIsLogged("koszyk_" + basketId);
    }

    // const PURCHASE_TYPE_RADIO_ID = "purchase_type_radio_id";
    // const PURCHASE_TYPE_CHECK_ID = "purchase_type_checkbox_id";
    // const PURCHASE_TYPE_PRIVATE = "priv";
    // const PURCHASE_TYPE_INVOICE = "inv";

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const { setActiveStepId, order, setOrder, isUserInfoRead, setIsUserInfoRead } = useCartContext();

    /* wyślij zapytanie o dane użytkownika do API */
    const succ_callback = (result: any) => {
        //console.log(result)

        /* przypisuję dane domyślne */

        let aName = result.first_name + " " + result.last_name;
        if (setOrder) {
            // setOrders(result.orders)
            setOrder({
                ...order,
                addrContact: {
                    ...order?.addrContact,
                    aName: aName,
                    email: result.email,
                    tel: result.tel,
                },
                addrPayer: {
                    ...result.default.addrPayer,
                    addrType: ADDR_TYPE_CHOICES.ADDR_TYPE_PAYER_BY_USER,
                },
                addrRecipient: {
                    ...result.default.addrRecipient,
                    addrType: ADDR_TYPE_CHOICES.ADDR_TYPE_RECIPIENT_BY_USER,
                },
                invoice: result.default.invoice,
                recipent: result.default.recipient,
            });
        }
        if (setIsUserInfoRead) setIsUserInfoRead(true);

        /* to jest konieczne, aby skoasować informację o błędzie, jeżeli była tam chwilę wcześniej */
        // if (notification)
        //   setNotification("");
    };

    const err_callback = (result: any) => {
        //setNotification(RequestClass.errorAlert(result));
        if (setIsUserInfoRead) setIsUserInfoRead(true);
    };

    useEffect(() => {
        if (isUserInfoRead === false) RequestClass.makeRequest("usr/", null, succ_callback, err_callback);
    }, [isUserInfoRead]);

    function onSubmitNext(data: any) {
        if (setActiveStepId) setActiveStepId(3);
    }

    function onSubmitPrev(data: any) {
        if (setActiveStepId) setActiveStepId(1);
    }

    // function onChange(e: React.ChangeEvent<HTMLInputElement>) {
    //     if (setOrder) {
    //         if (e.target.id === PURCHASE_TYPE_CHECK_ID) {
    //                 setOrder({...order, recipent:e.target.checked})
    //         }
    //         else if (e.target.id === PURCHASE_TYPE_RADIO_ID) {

    //             if (e.target.value === PURCHASE_TYPE_PRIVATE) {
    //                 setOrder({...order, invoice:false})
    //                 //setOrder({...order, invoiceType:INVOICE_CHOICES.INVOICE_PRIV})
    //             } else {
    //                 setOrder({...order, invoice:true})
    //                 //setOrder({...order, invoiceType:INVOICE_CHOICES.INVOICE_PAYER})
    //             }
    //         }
    //     }
    // }

    return (
        /* "handleSubmit" will validate your inputs before invoking "onSubmit" */
        <>
            {!isUserInfoRead && <>Proszę czekać pobieranie danych użytkownika.</>}

            {isUserInfoRead && (
                <form>
                    <InvoiceFormInputs classNames="center-with-margin" order={order} setOrder={setOrder} register={register} errors={errors} />

                    <div className="mt-5 has-text-centered">
                        <div className="mr-2 button is-primary next-step" onClick={onSubmitPrev}>
                            <i className="mr-2 fas fa-chevron-left"></i> Wstecz
                        </div>
                        <div className="button is-primary next-step" onClick={handleSubmit(onSubmitNext)}>
                            Przejdź dalej <i className="ml-2 fas fa-chevron-right"></i>
                        </div>
                    </div>
                </form>
            )}
        </>
    );
};

export default CartCustomerDetails;
